export const AuthBackdrop = ({ children, testid }) => (
  <div className="auth-wrap" data-testid={testid}>
    <div className="auth-bg" aria-hidden="true" />
    <div className="auth-shade" aria-hidden="true" />
    <div className="auth-card">{children}</div>
  </div>
);
